<template>
	<div class="answer-list">
		<div class="card">
			<div class="card-body detail-box">
				<div class="mb-3">
					<span class="titles"> {{ visits.survey.verbose_name }}</span>
				</div>
				<div class="dash-card">
					<!-- <span class="details">ادرس مشتری:{{ visits.outlet.address }}</span>
					<span class="details">کد مشتری:{{ visits.outlet.code }}</span> -->
					<span class="details" v-if="visits.city.name">شهر:{{ visits.city.name }}</span>
					<span class="details" v-if="visits.province.name">استان:{{ visits.province.name }}</span>
					<span class="details" v-if="visits.survey.verbose_name">
						نام پرسش‌نامه:{{ visits.survey.verbose_name }}</span
					>
					<span class="details" v-if="visits.user.first_name"
						>نیروی اجرایی:{{ visits.user.first_name + ' ' + visits.user.last_name }}</span
					>
					<span class="details" v-if="visits.datetime_created"
						>زمان پاسخدهی :

						<date-picker
							v-model="visits.datetime_created"
							type="datetime"
							format="YYYY-MM-DD HH:mm"
							display-format="jYYYY-jMM-jDD HH:mm"
							:timezone="true"
							:disabled="true"
						/>
					</span>

					<!-- <div>
						<p>بازخورد</p>
						<span>کاربر: {{ modalName }} {{ modalLastName }}</span>
						<b-form-textarea
							id="textarea"
							v-model="commentData.visit_comment"
							placeholder=""
							rows="3"
							max-rows="6"
							class="mt-2"
							style="border-radius: 4px"
						></b-form-textarea>
						<div class="d-flex flex-row justify-content-end w-100 mt-3">
							<button @click="acceptComment" class="accept-modal">ذخیره</button>
						</div>
					</div> -->
				</div>
			</div>
		</div>

		<div v-for="list in catList" :key="'cat' + list.id" class="card mt-4">
			<div class="card-body">
				<div class="mb-3">
					<span class="answers-title"> {{ list.verbose_name }}</span>
				</div>
				<div class="d-flex justify-content-between">
					<div class="flex-column w-50">
						<div class="mb-4" v-for="answers in answerList" :key="'answer' + answers.id">
							<div v-if="list.id === answers.survey_question.survey_report_category.id">
								<p class="titles">{{ answers.survey_question.text }}</p>
								<p class="short_text">{{ answers.survey_question.short_text }}</p>
								<div v-for="answerType in answers.survey_question.answer_type" :key="answerType.id">
									<div
										class="d-flex flex-row align-items-center"
										v-if="answerType.name === 'YesNo'"
									>
										<div class="box">
											<span class="answers-box" v-if="answers.bool === true"> بله</span>
											<span class="answers-box" v-if="answers.bool === false"> خیر</span>
										</div>
										<img
											class="edit-icon"
											@click="editFeild(answers)"
											src="../../assets/images/iconPack/edit1.png"
										/>
									</div>
									<div
										class="d-flex flex-row align-items-center"
										v-if="answerType.name === 'Triple'"
									>
										<div class="box">
											<span class="answers-box" v-if="answers.bool === true"> بله</span>
											<span class="answers-box" v-if="answers.bool === false"> خیر</span>
											<span class="answers-box" v-if="answers.bool === null"> ندارد</span>
										</div>
										<img
											class="edit-icon"
											@click="editFeild(answers)"
											src="../../assets/images/iconPack/edit1.png"
										/>
									</div>
									<div
										class="d-flex flex-row align-items-center"
										v-if="answerType.name === 'Input'"
									>
										<div class="box">
											<span class="answers-box">{{ answers.text }}</span>
										</div>
										<img
											class="edit-icon"
											@click="editFeild(answers)"
											src="../../assets/images/iconPack/edit1.png"
										/>
									</div>
									<div v-if="answerType.name === 'Score'">
										<div class="d-flex flex-row align-items-center">
											<div class="box">
												<span class="persian-number" v-if="answers.score === 1">1</span>
												<span class="persian-number" v-if="answers.score === 2">2</span>
												<span class="persian-number" v-if="answers.score === 3">3</span>
												<span class="persian-number" v-if="answers.score === 4">4</span>
												<span class="persian-number" v-if="answers.score === 5">5</span>
											</div>
											<img
												class="edit-icon"
												@click="editFeild(answers)"
												src="../../assets/images/iconPack/edit1.png"
											/>
										</div>
									</div>
									<div v-if="answerType.name === 'RadioChoice'">
										<div class="d-flex flex-row align-items-center">
											<div class="box">
												<span class="answers-box">{{ answers.radio.answer }}</span>
											</div>
											<img
												class="edit-icon"
												@click="editFeild(answers)"
												src="../../assets/images/iconPack/edit1.png"
											/>
										</div>
									</div>
									<div v-if="answerType.name === 'DropDownList'">
										<div class="d-flex flex-row align-items-center">
											<div class="box">
												<span class="answers-box">{{ answers.dropdown.answer }}</span>
											</div>
											<img
												class="edit-icon"
												@click="editFeild(answers)"
												src="../../assets/images/iconPack/edit1.png"
											/>
										</div>
									</div>
									<div class="d-flex align-items-center" v-if="answerType.name === 'Description'">
										<textarea
											:disabled="true"
											v-model="answers.description"
											rows="4"
											cols="50"
											class="mt-4"
											style="border-radius: 8px"
										>
										</textarea>
										<img
											class="edit-icon"
											@click="editFeild(answers)"
											src="../../assets/images/iconPack/edit1.png"
										/>
									</div>
									<div class="d-flex" v-if="answerType.name === 'Multichoice'">
										<div class="d-flex flex-row">
											<div
												v-for="multiAnswers in answers.multichoice"
												:key="multiAnswers.id"
												class="box"
											>
												<span class="answers-box"> {{ multiAnswers.answer }} </span>
											</div>
										</div>
										<img
											class="edit-icon"
											@click="editMultiFeild(answers)"
											src="../../assets/images/iconPack/edit1.png"
										/>
									</div>

									<div class="d-flex align-items-center" v-if="answerType.name === 'Number'">
										<span class="short-text">{{ answers.survey_question.short_text }} :</span>
										<div class="box">
											<span class="answers-box"> {{ answers.number }} </span>
										</div>
										<img
											class="edit-icon"
											@click="editFeild(answers)"
											src="../../assets/images/iconPack/edit1.png"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="d-flex flex-wrap w-50 justify-content-end">
						<div v-for="(image, index) in images" :key="image.id">
							<div
								class="ml-3 mb-3"
								v-if="list.id === image.survey_photo_type.survey_report_category.id"
							>
								<img @click="callModalimage(index)" class="answers-images" :src="image.link" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="btns justify-content-start mr-3">
				<button class="accept" @click="nullAnswers">افزودن پاسخ</button>
			</div>
			<b-modal v-model="nullAnswersQuest" hide-footer hide-header centered>
				<div v-for="nullAnswers in nullAnswersLists" :key="nullAnswers.id">
					<div class="modal-question-container" v-if="nullAnswers.submitted_answer.id === null">
						{{ nullAnswers.question.text }}
						<button @click="createFeild(nullAnswers)" class="select-questions">افزودن پاسخ</button>
					</div>
				</div>
			</b-modal>
		</div>
		<b-modal hide-footer hide-header centered v-model="editModal">
			<div class="py-3 d-flex flex-column">
				<span class="font-weight-bold mb-2">ویرایش اطلاعات</span>
				<span class="question-txt">{{ modaltext }}</span>
				<span class="question-txt font-weight-bold">{{ modalShortText }}</span>

				<div v-for="model in modalAnswerType" :key="model.id">
					<select class="w-100" v-model="modalBool" v-if="model.name === 'YesNo'">
						<option :value="true">بله</option>
						<option :value="false">خیر</option>
					</select>
					<select class="w-100" v-model="modalBool" v-if="model.name === 'Triple'">
						<option :value="true">بله</option>
						<option :value="false">خیر</option>
						<option :value="null">ندارد</option>
					</select>
					<select class="w-100" v-model="modalScore" v-if="model.name === 'Score'">
						<option :value="1">‍۱</option>
						<option :value="2">۲</option>
						<option :value="3">۳</option>
						<option :value="4">۴</option>
						<option :value="5">۵</option>
					</select>

					<div v-if="model.name === 'RadioChoice'">
						<b-form-group>
							<b-form-radio-group
								v-model="modalRadio"
								:options="modalRadioChoices"
								value-field="id"
								text-field="answer"
								class="d-flex flex-column"
							></b-form-radio-group>
						</b-form-group>
					</div>

					<div class="w-100" v-if="model.name === 'DropDownList'">
						<Multiselect
							:options="modalDropdownChoice"
							v-model="modalDropdownAnswer"
							:custom-label="customLabel"
							placeholder="لطفا یک مورد را انتخاب نمایید"
							selectLabel=""
							class="mt-4"
							@select="modalDropdownAnswer"
						></Multiselect>
					</div>

					<input class="w-100" v-if="model.name === 'Input'" v-model="modalInput" />
					<textarea
						v-if="model.name === 'Description'"
						v-model="ModalDescription"
						rows="4"
						cols="50"
						class="mt-4 w-100"
						style="border-radius: 8px"
					>
					</textarea>
					<input
						class="my-2 edit-input w-100"
						v-if="model.name === 'Number'"
						v-model="modalNumberValue"
					/>
					<div v-if="model.name === 'Multichoice'">
						<p class="font-weight-bold">{{ multiChooseQuestion }}</p>
						<div v-for="multi in multiAnswerChooses" :key="multi.id">
							<input v-model="multiChoose" :value="multi.id" class="ml-2" type="checkbox" />
							<label>{{ multi.answer }}</label>
						</div>
					</div>
				</div>
			</div>
			<div class="btns">
				<button class="accept" @click="submitEdit">ثبت</button>
				<button @click="editModal = !editModal" class="reject">بستن</button>
			</div>
		</b-modal>
		<div v-if="verifyProfileData.length" class="card mt-3">
			<div class="card-body detail-box w-25">
				<div class="mb-3">
					<span class="titles">استعلام</span>
				</div>
				<div class="mb-3">
					<p class="titles">کد ملی</p>
					<div class="box">
						{{ verifyProfileData[0].national_id }}
					</div>
				</div>
				<div class="mb-3">
					<p class="titles">شماره موبایل</p>
					<div class="box">
						{{ verifyProfileData[0].phone_number }}
					</div>
				</div>
				<div class="mb-3">
					<p class="titles">شماره شبا</p>
					<div class="box">
						{{ verifyProfileData[0].sheba_number }}
					</div>
				</div>
				<div class="mb-3">
					<p class="titles">تاریخ تولد</p>
					<div class="box">
						{{ verifyProfileData[0].birth_date }}
					</div>
				</div>
				<div></div>
			</div>
		</div>
		<div class="image-box">
			<div class="btns mt-4 justify-content-start">
				<button @click="importImg" class="accept">افزودن عکس</button>
			</div>
			<b-modal hide-footer hide-header centered v-model="modalAddImage">
				<h5 class="mb-4">افزودن عکس</h5>
				<div v-for="photos in storeDetailPhotos" :key="photos.id">
					<div class="modal-question-container">
						<span>{{ photos.verbose_name }}</span>
						<button @click="uploadImage(photos.id)" class="select-questions">افزودن عکس</button>
						<input
							type="file"
							hidden
							capture="user"
							accept="image/*"
							id="fileUpload"
							@change="func($event)"
						/>
					</div>
				</div>
			</b-modal>

			<Tableview
				:hover="true"
				:bordered="true"
				class="mt-4"
				:showNoContent="showContnetFunc"
				:showNoData="showDataFunc"
			>
				<template #TableTitle>
					<tr>
						<th>ردیف</th>
						<th>عنوان</th>
						<th>تصویر</th>
						<th>تایید تصویر</th>
						<th>نتیجه پردازش</th>
						<th>تاریخ</th>
						<th>لوکیشن</th>
						<th>عملیات</th>
					</tr>
				</template>

				<template #TableBody>
					<tr v-for="(item, index) in images" :key="item.id">
						<td class="persian-number">
							{{ 1 + index }}
						</td>
						<td>{{ item.survey_photo_type.verbose_name }}</td>
						<td>
							<img @click="callModalimage(index)" class="images" :src="item.link" />
						</td>
						<td>
							<img
								@click="verifyImage(item)"
								class="images"
								src="../../assets//images/iconPack/auth-img.svg"
							/>
						</td>
						<td>
							<span v-if="item.recognition_status == null">نامشخص</span>
							<span v-if="item.recognition_status == 1">نقص پروفایل</span>
							<span v-if="item.recognition_status == 2">عدم تشخیص چهره</span>
							<span v-if="item.recognition_status == 3">عدم تطابق</span>
							<span v-if="item.recognition_status == 4">تطابق</span>
						</td>
						<td>
							<date-picker
								v-model="item.datetime_created"
								type="datetime"
								format="YYYY-MM-DD HH:mm"
								display-format="jYYYY-jMM-jDD HH:mm"
								:timezone="true"
								:disabled="true"
							/>
						</td>
						<td>
							<span class="location" @click="showLocation(item)">مشاهده</span>
						</td>
						<td>
							<img
								class="delete-img"
								@click="modalDeleteImg(item)"
								src="@/assets/images/iconPack/red-trash.svg"
							/>
							<img class="star-img" :src="item.is_favourite ? dislikeComputed : likeComputed" @click="likeHandlerClick(item)" />
						</td>
					</tr>
				</template>
			</Tableview>
			<b-modal hide-footer hide-header size="lg" centered v-model="imageModal">
				<b-carousel
					id="carousel-fade"
					style="text-shadow: 1px 1px 2px #333"
					v-if="images.length"
					controls
					indicators
					background="#ababab"
					fade
					v-model="carouselIndex"
					interval="120000"
				>
					<b-carousel-slide
						v-for="(image, index) in images"
						:key="index"
						:img-src="image.link"
					></b-carousel-slide>
				</b-carousel>
				<!-- <img class="modal-img" :src="imageUrl" /> -->
			</b-modal>
			<b-modal hide-footer hide-header centered v-model="modalTrash">
				<h5 class="mb-4">حذف عکس</h5>
				<span>آیا از حذف این عکس اطمینان دارید؟</span>
				<div class="btns mt-4">
					<button @click="deleteImg" class="accept">تایید</button>
					<button @click="modalTrash = !modalTrash" class="reject">رد</button>
				</div>
			</b-modal>
			<div class="btns pb-4">
				<button @click="modalShow = !modalShow" class="accept">تایید</button>
				<!-- <button @click="rejectModal = !rejectModal" class="reject">رد</button> -->

				<b-modal v-model="modalShow" hide-footer hide-header centered>
					<p class="my-4">آیا از تایید خود اطمینان دارید؟</p>
					<div class="btns">
						<button @click="acceptVist" class="accept">تایید</button>
						<button @click="modalShow = !modalShow" class="reject">بستن</button>
					</div>
				</b-modal>
				<b-modal v-model="rejectModal" hide-footer hide-header centered>
					<p class="my-4">آیا از رد کردن اطمینان دارید؟ دلیل را توضیح دهید</p>
					<textarea
						style="border-radius: 8px"
						class="text-area"
						rows="4"
						cols="50"
						v-model="rejectReason"
					></textarea>
					<div class="btns">
						<button :disabled="reasonBtn" class="accept">تایید</button>
						<!-- <button @click="rejectModal = !rejectModal" class="reject">بستن</button> -->
					</div>
				</b-modal>
			</div>
		</div>
		<Loading v-if="loading" />
	</div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';
import Multiselect from 'vue-multiselect';
import axios from 'axios';
import Loading from '../../components/Loading/index.vue';
export default {
	components: {
		Tableview,
		Multiselect,
		Loading,
	},
	data() {
		return {
			catList: [],
			answerList: [],
			visits: {},
			images: 0,
			storeDetailPhotos: [],
			imageModal: false,
			modalShow: false,
			rejectModal: false,
			rejectReason: null,
			imageUrl: null,
			editModal: false,
			modaltext: '',
			modalAnswerType: [],
			modalNumberValue: null,
			modalAnswerId: '',
			modalShortText: '',
			modalBool: null,
			modalScore: null,
			ModalDescription: null,
			modalAddImage: false,
			photoId: null,
			modalTrash: false,
			imgId: null,
			multiChoose: [],
			multiAnswerChooses: [],
			multiChooseQuestion: '',
			modalInput: null,
			modalRadio: null,
			modalDropdownAnswer: {},
			modalDropdownChoice: [],
			modalRadioChoices: [],
			nullAnswersQuest: false,
			nullAnswersLists: [],
			modalQuestionId: null,
			surveyFillOutId: window.location.href.split('/').slice(-1)[0],
			targetIndex: 2,
			loading: false,
			carouselIndex: 0,
			verifyProfileData: [],
			likeImageSrc: 'Stal-line.svg',
			dislikeImageSrc:'Star-filled.svg',
			like: false,
			// commentData: {},
			// modalName: '',
			// modalLastName: '',
		};
	},
	async mounted() {
		await this.getAnswerList();
		this.getCategoryList();
		this.getImageList();
		this.getVisitSetting();
		this.verifyProfile();
		// this.comment();
	},
	computed: {
		reasonBtn() {
			if (this.rejectReason === null || this.rejectReason.length === 0) {
				return true;
			} else {
				return false;
			}
		},
		showContnetFunc() {
			return this.images === 0;
		},
		showDataFunc() {
			if (this.images.length !== undefined) {
				return this.images.length === 0;
			}
			return false;
		},

		likeComputed() {
			return require(`@/assets/images/iconPack/${this.likeImageSrc}`);
		},
		dislikeComputed() {
			return require(`@/assets/images/iconPack/${this.dislikeImageSrc}`);
		}
	},
	methods: {
		// getImageSrc(item) {
		// 	return require(`@/assets/images/iconPack/${item.is_favourite ? 'Star-filled.svg' : 'Stal-line.svg'}`);
		// },
		customLabel({ answer }) {
			return `${answer}`;
		},
		async getCategoryList() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.SUVEY_CATEGORY_LIST +
					'?survey_fill_out_id=' +
					lastParam +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				{},
			);
			if (res.status === 200) {
				this.catList = res.data;
			}
		},
		async nullAnswers() {
			this.nullAnswersQuest = true;
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.GET_SURVEY_QUESTION +
					lastParam +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.nullAnswersLists = res.data;
				'list', res.data;
			}
		},
		async verifyImage(item) {
			this.loading = true;
			const apiUrl = 'https://face.koosha.ir/recognize/check_face/';
			axios
				.post(apiUrl, {
					matching_id: item.survey_fill_out.user.id,
					image: item.link,
					is_for: 'S',
					for_id: item.id,
				})
				.then((response) => {
					if (response.data.result.is_matched === true) {
						this.loading = false;
						this.$notify({
							group: 'tc',
							type: 'success',
							text: 'تصویر مطابقت دارد.',
						});
					} else {
						this.loading = false;
						this.$notify({
							group: 'tc',
							type: 'danger',
							text: 'تصویر مطابقت ندارد.',
						});
					}
					response;
				})
				.catch(() => {
					this.loading = false;
					this.getImageList();
					this.$notify({
						group: 'tc',
						type: 'danger',
						text: ' کاربر مورد نظر بخش احراز هویت را تکمیل نکرده است!',
					});
				});
		},

		async getVisitSetting() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.SURVEY_PAGE_SETTING +
					lastParam +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.storeDetailPhotos = res.data.photos;
			}
		},

		uploadImage(id) {
			this.photoId = id;
			document.getElementById('fileUpload').click();
		},
		modalDeleteImg(item) {
			this.modalTrash = true;
			this.imgId = item.id;
		},
		async submitEdit() {
			let res = null;
			this.loading = true;
			console.log(this.multiChoose);
			const data = {
				score: this.modalScore,
				bool: this.modalBool,
				description: this.ModalDescription,
				number: this.modalNumberValue,
				multichoice: this.multiChoose,
				text: this.modalInput,
				radio: this.modalRadio,
				dropdown: this.modalDropdownAnswer !== null ? this.modalDropdownAnswer.id : null,
				survey_question: this.modalQuestionId,
				survey_fill_out: this.surveyFillOutId,
			};
			if (this.modalAnswerId === null) {
				res = await this.$ApiServiceLayer.post(
					this.$PATH.RELATIVE_PATH.MULTI.SURVEY_ANSWER_LIST +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
					this.$PATH.SERVICE_NAME.AUTH,
					data,
					{},
					true,
				);
			} else {
				res = await this.$ApiServiceLayer.patch(
					this.$PATH.RELATIVE_PATH.MULTI.SURVEY_EDIT_ANSWER + this.modalAnswerId + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
					this.$PATH.SERVICE_NAME.AUTH,
					data,
					{},
					true,
				);
			}
			if (res.status === 200 || res.status === 201) {
				this.loading = false;
				this.$notify({
					group: 'tc',
					type: 'success',
					text: ' بروزرسانی با موفقیت انجام شد.',
				});
				this.getAnswerList();
				this.nullAnswers();
				this.editModal = false;
				this.nullAnswersQuest = false;
			}
		},
		async func(event) {
			this.loading = true;
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			'thisis:', event.target.files[0];
			let formData = new FormData();
			formData.append('link', event.target.files[0]);
			formData.append('latitude', null);
			// formData.append("latitude", "10");
			formData.append('longitude', null);
			// formData.append("longitude", "10");
			formData.append('survey_fill_out', lastParam);
			formData.append('survey_photo_type', this.photoId);
			const res = await this.$ApiServiceLayer.post(
				this.$PATH.RELATIVE_PATH.MULTI.SURVEY_PHOTO_UPLOAD +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				formData,
				{
					'Content-Type': 'multipart/form-data',
				},
			);
			if (res.status === 200) {
				this.loading = false;
				this.$notify({
					group: 'tc',
					type: 'success',
					text: ' بارگزاری با موفقیت انجام شد.',
				});
				this.modalAddImage = false;
				this.getImageList();
			}
		},
		async likeHandlerClick(item) {
			this.imgId = item.id;
			const res = await this.$ApiServiceLayer.patch(
				this.$PATH.RELATIVE_PATH.MULTI.SURVEY_DELETE_IMAGE +
					this.imgId +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				{ is_favourite: !item.is_favourite },
			);
			if (res.status === 200) {
				this.getImageList();

			}
		},
		callModalimage(index) {
			this.imageModal = true;
			this.carouselIndex = index;
			// this.imageUrl = item.link;
		},
		editFeild(answers) {
			this.modalQuestionId = answers.survey_question.id;
			this.modaltext = answers.survey_question.text;
			this.modalNumberValue = answers.number;
			this.modalShortText = answers.survey_question.short_text;
			this.modalBool = answers.bool;
			this.modalScore = answers.score;
			this.ModalDescription = answers.description;
			this.modalAnswerId = answers.id;
			this.modalAnswerType = answers.survey_question.answer_type;
			this.modalInput = answers.text;
			this.modalRadio = answers.radio !== null ? answers.radio.id : null;
			this.modalRadioChoices = answers.survey_question.radio_choices;
			this.modalDropdownAnswer = answers.dropdown;
			this.modalDropdownChoice = answers.survey_question.dropdown_choices;
			this.editModal = true;
		},
		createFeild(answers) {
			this.modalQuestionId = answers.question.id;
			this.surveyFillOutId = window.location.href.split('/').slice(-1)[0];
			this.modaltext = answers.question.text;
			this.modalNumberValue = answers.submitted_answer.number;
			this.modalShortText = answers.question.short_text;
			this.modalBool = answers.submitted_answer.bool;
			this.modalScore = answers.submitted_answer.score;
			this.ModalDescription = answers.submitted_answer.description;
			this.modalAnswerId = answers.submitted_answer.id;
			this.modalAnswerType = answers.question.answer_type;
			this.modalInput = answers.submitted_answer.text;
			this.modalRadio =
				answers.submitted_answer.radio !== null ? answers.submitted_answer.radio.id : null;
			this.modalRadioChoices = answers.question.radio_choices;
			this.modalDropdownAnswer = answers.submitted_answer.dropdown;
			this.modalDropdownChoice = answers.question.dropdown_choices;
			this.editModal = true;
		},
		editMultiFeild(answers) {
			this.modalQuestionId = answers.survey_question.id;
			// ('assd',answers)
			this.modalAnswerType = answers.survey_question.answer_type;
			this.modalAnswerId = answers.id;
			// this.multiChoose = answers.multichoice;
			this.getMultiChoose(answers.id);
			this.multiChooseQuestion = answers.survey_question.text;
		},
		async getMultiChoose(id) {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.SURVEY_EDIT_ANSWER +
					id +
					'/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.editModal = true;
				this.multiAnswerChooses = res.data.survey_question.answer_choices;
			}
		},
		// async comment() {
		// 	const url = window.location.href;
		// 	const lastParam = url.split('/').slice(-1)[0];
		// 	const res = await this.$ApiServiceLayer.get(
		// 		this.$PATH.RELATIVE_PATH.MULTI.ADD_COMMENT + lastParam + '/',
		// 		this.$PATH.SERVICE_NAME.AUTH,
		// 		{},
		// 	);
		// 	if (res.status === 200) {
		// 		('co', res.data);
		// 		this.commentData = res.data;
		// 		this.modalName = res.data.comment_publisher.first_name;
		// 		this.modalLastName = res.data.comment_publisher.last_name;
		// 	}
		// },
		// async acceptComment() {
		// 	const url = window.location.href;
		// 	const lastParam = url.split('/').slice(-1)[0];
		// 	const res = await this.$ApiServiceLayer.put(
		// 		this.$PATH.RELATIVE_PATH.MULTI.ADD_COMMENT + lastParam + '/',
		// 		this.$PATH.SERVICE_NAME.AUTH,
		// 		{
		// 			visit_comment: this.commentData.visit_comment,
		// 		},
		// 	);
		// 	if (res.status === 200) {
		// 		this.$notify({
		// 			group: 'tc',
		// 			type: 'success',
		// 			text: 'بازخورد با موفقیت تغییر کرد!',
		// 		});
		// 	}
		// },
		async getAnswerList() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.SURVEY_ANSWER_LIST +
					'?ordering=survey_question__priority&survey_fill_out=' +
					lastParam +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.answerList = res.data;
				this.visits = res.data[0].survey_fill_out;
				this.questions = res.data.question;
			}
		},

		async getImageList() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.SURVEY_PHOTO_LIST +
					'?survey_fill_out=' +
					lastParam +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.images = res.data;
				'images:', res.data;
			}
		},
		importImg() {
			this.modalAddImage = true;
			this.getImageList();
		},
		deleteImg() {
			this.$ApiServiceLayer
				.delete(
					this.$PATH.RELATIVE_PATH.MULTI.SURVEY_DELETE_IMAGE + this.imgId + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
					this.$PATH.SERVICE_NAME.AUTH,
				)
				.then((response) => {
					if (response.status === 204) {
						this.$notify({
							group: 'tc',
							type: 'success',
							text: ' حذف عکس با موفقیت انجام شد.',
						});
						this.modalTrash = false;
						this.getImageList();
					}
				});
		},
		showLocation(item) {
			window.open(`https://maps.google.com/?q=${item.latitude},${item.longitude}`, '_blank');
		},
		async acceptVist() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.patch(
				this.$PATH.RELATIVE_PATH.MULTI.SURVEY_EDIT + lastParam + '/' +
					'?p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
				{ status: '2' },
			);
			if (res.status === 200) {
				window.close();
			}
		},
		// async rejectVisit() {
		// 	const url = window.location.href;
		// 	const lastParam = url.split('/').slice(-1)[0];
		// 	const res = await this.$ApiServiceLayer.put(
		// 		this.$PATH.RELATIVE_PATH.MULTI.VISITS_STATUS + lastParam + '/',
		// 		this.$PATH.SERVICE_NAME.AUTH,
		// 		{ status: '4', rejection_reason: this.rejectReason },
		// 	);
		// 	if (res.status === 200) {
		// 		window.close();
		// 	}
		// },
		async verifyProfile() {
			const url = window.location.href;
			const lastParam = url.split('/').slice(-1)[0];
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.GET.PERSONAL_INFO_VALIDATE +
					`?survey_fillout=${lastParam}` +
					'&is_main=true' +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.EMPTY,
			);
			if (res.status === 200) {
				this.verifyProfileData = res.data;
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.answer-list {
	padding: 24px;
	.detail-box {
		padding: 14px 24px;
		.titles {
			font-size: 18px;
		}
	}
	.dash-card {
		border: 1px dashed #c4c4c4;
		border-radius: 8px;
		padding: 16px;
		margin-bottom: 50px;
		background: #fff;
		border-radius: 8px;
	}
	.details {
		display: flex;
		align-items: center;
		font-size: 14px;
		margin-top: 8px;
		font-family: 'IRANYekanfa' !important;
		&:last-child {
			flex-direction: row;
			align-items: center;
			margin-top: 0;
		}
	}
	.box {
		background: #d9d9d9;
		border-radius: 8px;
		padding: 10px;
		min-width: 72px;
		display: flex;
		justify-content: center;
		margin-left: 10px;
		border-radius: 8px;
		font-family: 'IRANYekanfa' !important;

		.answers-box {
			font-size: 14px;
			color: #616162;
		}
		.persian-number {
			font-family: 'IRANYekanfa' !important;
			font-size: 14px;
			color: #616162;
		}
	}
	.images {
		max-width: 60px;
		border-radius: 8px;
	}
	.location {
		color: #007bff !important;
		cursor: pointer;
	}
}
.question-txt {
	font-size: 14px;
	margin-top: 8px;
}
.btns {
	display: flex;
	justify-content: flex-end;
	margin-bottom: 15px;
	.accept {
		background: #2d8b8b;
		border-radius: 8px;
		color: #fff;
		padding: 8px 40px;
		border: none !important;
		margin-left: 10px;
		border-radius: 8px;
	}
	.accept:disabled {
		background: #c4c4c4;
	}
	.reject {
		border: 1px solid #2d8b8b !important;
		border-radius: 8px;
		padding: 8px 40px;
		background: #fff;
		border-radius: 8px;
	}
}
.edit-input {
	// border: 1px solid #c4c4c4;
	text-indent: 10px;
	border-radius: 8px;
	font-family: 'IRANYekanfa' !important;
}
.modal-img {
	width: 100%;
}
.edit-icon {
	width: 25px;
	height: 25px;
}
.text-area {
	width: 100%;
	border: 1px solid #c4c4c4;
	border-radius: 8px;
	margin-bottom: 16px;
	padding: 4px;
	border-radius: 8px;
}
.short-text {
	font-weight: bold;
	margin-left: 10px;
}
.persian-number {
	font-family: 'IRANYekanfa' !important;
}
.modal-question-container {
	display: flex;
	justify-content: space-between;
	border: 1px dotted #c4c4c4;
	margin-bottom: 10px;
	padding: 8px;
	align-items: center;
}
.select-questions {
	background: #2d8b8b;
	border-radius: 8px;
	color: #fff;
	padding: 8px 10px;
	border: none;
}

.delete-img {
	max-width: 32px;
	cursor: pointer;
}
.star-img {
	margin-right: 8px;
	max-width: 24px;
	cursor: pointer;
}
.answers-title {
	font-size: 18px;
	font-weight: 700;
}
.answers-images {
	max-width: 120px;
	border-radius: 8px;
}
.accept-modal {
	height: 38px;
	background: #2d8b8b;
	color: #fff;
	border: none !important;
	margin-left: 10px;
	min-width: 100px;
	border-radius: 8px;
}
.card {
	border: none !important;
	border-radius: 8px !important;
}
.image-box {
	background: #fff;
	padding: 24px;
	margin-top: 1.5rem;
}
.short_text {
	color: #c4c4c4;
	font-size: 16px;
}
</style>

<style>
.vpd-icon-btn {
	display: none !important;
}
.vpd-input-group input {
	border: none !important;
	border-radius: 0;
	font-family: 'IRANYekanfa';
}
.vpd-input-group input:disabled {
	background: #fff;
	min-width: 130px;
	text-align: center;
}
.multiselect {
	text-align: right !important;
}
.multiselect__select {
	display: none !important;
}
.multiselect__tags {
	padding: 8px 20px 0 8px !important;
}
.custom-control-label::before {
	left: unset !important;
	margin-left: 20px;
	position: unset !important;
}

.custom-control-label {
	display: flex !important;
	align-items: center;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
